import { createFileRoute } from "@tanstack/react-router";
import { requireCompleteProfile } from "@/lib/auth-guard";
import { useQuery } from "@tanstack/react-query";
import { pb } from "@/lib/pocketbase";
import { Collections } from "@/types/pocketbase-types";
import type { SourcesResponse } from "@/types/pocketbase-types";

import ArticleHero from "@/components/application/articles/ArticleHero";
// import TodaysArticles from '@/components/application/articles/TodaysArticles'
import PreviousArticles from "@/components/application/articles/PreviousArticles";
import LoadingSpinner from "@/components/LoadingSpinner";

const ArticlesIndexPage = () => {
  // Fetch articles from sources collection
  const {
    data: _sources = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["articles"],
    queryFn: async (): Promise<SourcesResponse[]> => {
      const records = await pb.collection(Collections.Sources).getFullList({
        filter: 'status="processed"', // Only processed articles
        sort: "-created",
        expand: "section",
      });
      return records as unknown as SourcesResponse[];
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  if (isLoading) {
    return (
      <div className="pt-0">
        <ArticleHero />
        <LoadingSpinner text="Loading articles..." className="min-h-[400px]" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-0">
        <ArticleHero />
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="text-center">
            <div className="text-error-500 text-6xl mb-4">📰</div>
            <h2 className="text-xl font-bold text-error-500 mb-2">
              Failed to load articles
            </h2>
            <p className="text-neutral-500">{error.message}</p>
          </div>
        </div>
      </div>
    );
  }

  // Get today's articles
  // const today = new Date().toISOString().split('T')[0]
  // const todaysArticles = articlesByDate.get(today) || []

  return (
    <div className="pt-0">
      <ArticleHero />
      {/* <TodaysArticles articles={todaysArticles} /> */}
      <PreviousArticles />
    </div>
  );
};

export const Route = createFileRoute("/articles/")({
  ...requireCompleteProfile(),
  component: ArticlesIndexPage,
});
